<div class="raw-data-dialog">
  <div class="modal-header">
    <h3 class="modal-title">
      Raw data - {{ data.title }}
      <i (click)="close()" class="fa fa-times pull-right"></i>
      <i
        class="fa pull-right"
        [ngClass]="{
          'fa-plus-square-o': minimise,
          'fa-minus-square-o': !minimise,
        }"
        style="margin-right: 10px"
        (click)="minimise = !minimise"
      ></i>
    </h3>
  </div>

  <div class="modal-body raw-data" [hidden]="minimise">
    @if (data.data && data.data.length > 0) {
<div class="row">
      <div class="col-12">
        <div class="table-filter">
          <div class="raw-data-search">
            <input type="text"
                   class="form-control"
                   placeholder="Search..."
                   aria-label="Search raw data"
                   [(ngModel)]="globalFilter"
                   (ngModelChange)="applyGlobalFilter($event)">
            @if (globalFilter) {
              <button type="button"
                      class="raw-data-search-clear"
                      title="Clear search"
                      aria-label="Clear search"
                      (click)="clearGlobalFilter()">
                <i class="fa fa-times-circle" aria-hidden="true"></i>
              </button>
            }
          </div>
        </div>
        <div class="table-shell">
          <div class="table-scroll">
          <table mat-table [dataSource]="dataSource" matSort class="raw-data-mat-table dst-mat-table">
            @for (col of columns; track col.field) {
              <ng-container [matColumnDef]="col.field">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ col.header }}</th>
                <td mat-cell *matCellDef="let row" [innerHTML]="formatValue(row[col.field])"></td>
              </ng-container>
            }

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell raw-data-no-records" [attr.colspan]="displayedColumns.length">No records found</td>
            </tr>
          </table>
          </div>
          <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </div>
    }
    @if (!data.data || data.data.length === 0) {
<div class="raw-data-empty">
      No data available
    </div>
}
  </div>

  <div class="modal-footer" [hidden]="minimise">
    <div class="btn btn-sm btn-warning" (click)="close()">Close</div>
  </div>
</div>
